export const desktopLayout = ["none", null, null, "block"];
export const mobileLayout = ["block", null, null, "none"];
